import { inject, Injectable } from '@angular/core';
import { PageableDatasource } from '../../../shared/contract/pageable-datasource.contract';
import { PageableRequestParams } from '../../../shared/contract/pageable-request-params.contract';
import { SearchUsersRequest } from '../contract/requests/search-users-request.contract';
import { SearchUser } from '../contract/search-user.contract';
import { UserListConfigService } from './user-list-config.service';
import { UsersApiService } from './users-api.service';

@Injectable({ providedIn: 'root' })
export class UsersDatasourceService extends PageableDatasource<SearchUser> {
  private readonly listConfigService = inject(UserListConfigService);
  private readonly usersApiService = inject(UsersApiService);

  readonly contentEmitters = this.listConfigService.contentEmitters;

  constructor() {
    super();
    super.changePageSize(this.listConfigService.pageSize, false);
  }

  public requestData(params: PageableRequestParams | SearchUsersRequest): void {
    const request: SearchUsersRequest = {
      page: params.page,
      size: params.size,
      terms: (params as SearchUsersRequest).terms,
    };
    this.usersApiService.searchUsers(request).subscribe((resp) => {
      this.setPageableData(resp);
    });
  }

  public requestDataCrossOrganisation(params: SearchUsersRequest): void {
    this.usersApiService.getUsersCrossOrganisation(params).subscribe((resp) => {
      this.setPageableData(resp);
    });
  }

  override changePageSize(size: number, update = true): void {
    this.listConfigService.savePageSize(size);
    super.changePageSize(size, update);
  }
}
